import { render } from "./PreviewBankingReceipt.vue?vue&type=template&id=7ec74f9c&scoped=true&ts=true"
import script from "./PreviewBankingReceipt.vue?vue&type=script&lang=ts"
export * from "./PreviewBankingReceipt.vue?vue&type=script&lang=ts"

import "./PreviewBankingReceipt.vue?vue&type=style&index=0&id=7ec74f9c&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Medix_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec74f9c"]])

export default __exports__